<template>
  <div class="auto-loop-image">
    <div class="auto-loop-image-title"> {{ data?.title ?? '' }}</div>
    <div class="auto-loop-image-wrapper" @mouseenter="pauseScroll" @mouseleave="startScroll" :style="carouselStyle">
      <img v-for="(item, index) in extendedImages" :key="index" v-lazy="item?.url ?? ''" alt="" draggable="false"/>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  jsonData: Object
})

const data = reactive(props.jsonData)
const imageList = reactive([])
const translateX = ref(0)
const scrollSpeed = 1 // 控制滚动速度
let scrollInterval = null

// 将图片列表重复一份，以实现无缝滚动
const extendedImages = computed(() => [...imageList, ...imageList, ...imageList, ...imageList])

const startScroll = () => {
  scrollInterval = setInterval(() => {
    translateX.value -= scrollSpeed;
    // 如果滚动到第一组的末尾，将 translateX 复位到开头，实现无缝滚动
    const resetPosition = -(imageList.length * 300 + imageList.length * 20); // 每张图片宽度 + 间距
    if (translateX.value <= resetPosition) {
      translateX.value = 0;
    }
  }, 16); // 约等于60FPS
}

const pauseScroll = () => {
  clearInterval(scrollInterval);
}

const carouselStyle = computed(() => ({
  transform: `translateX(${translateX.value}px)`,
  transition: translateX.value === 0 ? 'none' : 'transform 0.3s linear' // 无缝复位时关闭过渡
}))

onBeforeMount(() => {
  imageList.push(...data.data.content)
})
onMounted(startScroll)
onUnmounted(pauseScroll)

// 监听 jsonData 变化并更新 data
watch(() => props.jsonData, (newValue) => {
  imageList.splice(0, imageList.length);
  imageList.push(...newValue.data.content)
}, {immediate: true})

</script>

<script>
export default {
  name: 'AutoLoopImageView' //导出组件名称
}
</script>

<style lang='less' scoped>

.auto-loop-image {
  overflow: hidden;
  margin-top: 50px;

  .auto-loop-image-title {
    font-size: 18px;
    color: var(--main-color);
    letter-spacing: 2px;
    font-weight: bold;
  }

  .auto-loop-image-wrapper {
    display: flex;
    margin-top: 50px;
    justify-content: flex-start; /* 图片从容器左侧开始排列 */
    align-items: center; /* 保证图片在容器中垂直居中对齐 */
    transition: transform 0.3s linear;
    gap: 30px;
    will-change: transform;

    img {
      height: 150px;
      max-width: 100%; /* 防止图片宽度超出容器 */
      object-fit: cover;
      border-radius: 4px;
    }
  }
}

</style>